import { Body1 } from '@sainsburys-tech/luna-typography'
import getRelativeDate from '../../../utils/getRelativeDate'
import { IEnforcementContactDescription } from '../../../types'

const EnforcementContactDescription = ({ contactDateTime, store }: IEnforcementContactDescription) => {

  const date = getRelativeDate({dateTime:contactDateTime ?? undefined, type:'date'})
  const time = getRelativeDate({dateTime: contactDateTime ?? undefined, type:'ecTime24'})

  return (
    <>
    <div id="s-reported-enforcement-contacts-card-description">
      <Body1
        className="ln-u-color-dark"
      >
        { date ? ("on " + date + " at " + time) : ''}
      </Body1>
    </div>
    
    <div>
      <Body1
        className="ln-u-font-weight-bold ln-u-color-dark"
      >
        {store ? ("in " + store) : ''}
      </Body1>
    </div>
    </>
  )
}

export default EnforcementContactDescription